<template lang="pug">
.robot-design.robot2s
  #design-b1.banner
    .w
      .p1(:class="{fadeUp: isB1Visible}") 极光流线型设计
      .p2.delay1(:class="{fadeUp: isB1Visible}") 处处彰显科技感
  #design-b2.banner
    .w
      .p1(:class="{fadeUp: isB2Visible}") V 字蓝光
      .p2.delay2(:class="{fadeUp: isB2Visible}") 闪耀光芒
  #design-b3.banner
    .w
      .p1(:class="{fadeUp: isB3Visible}") 36种拟人化表情
      .p2.delay1(:class="{fadeUp: isB3Visible}") 贴心动人
  #design-b4.banner
    .w
      .p1(:class="{fadeUp: isB4Visible}") 绝美音质
      .p2.delay1.mt10(:class="{fadeUp: isB4Visible}") 听音乐如临现场
</template>

<script>
import { isVisible } from '../../../common/utils'

export default {
  data () {
    return {
      isB1Visible: true,
      isB2Visible: false,
      isB3Visible: false,
      isB4Visible: false,
    }
  },
  computed: {},
  methods: {},
  created () {
    $(window).on('scroll', () => {
      this.isB1Visible = isVisible('#design-b1')
      this.isB2Visible = isVisible('#design-b2')
      this.isB3Visible = isVisible('#design-b3')
      this.isB4Visible = isVisible('#design-b4')
    })
  },
}
</script>

<style lang="stylus">
@import 'config'
.robot-design
  .w
    position relative
    height 100%
    .p1
      font-size 40px
    .p2
      font-size 16px
  &.robot2s
    color #fff
    #design-b1
      background-image url('../../../assets/web/2s-design-b1.jpg')
      padding-top 150px
      text-align center
    #design-b2
      background-image url('../../../assets/web/2s-design-b2.jpg')
      .p1,
      .p2
        position absolute
      .p1
        left 760px
        bottom 370px
      .p2
        left 930px
        bottom 377px

    #design-b3
      background-image url('../../../assets/web/2s-design-b3.jpg')
      .w
        padding 100px 0 0 10px
    #design-b4
      background-image url('../../../assets/web/2s-design-b4.jpg')
      .w
        text-align center
        padding-top 100px
      .p2
        line-height 1.8
        margin-bottom 90px
  .banner
    height 1000px
    min-width 1200px
    background-size auto 100%
    background-position center
    background-repeat no-repeat
.is-mobile
  .robot2s
    #design-b1, #design-b2, #design-b3, #design-b4
      width 100%
      min-width inherit
      height r(1100)
    #design-b1
      background-image url('../../../assets/mobile/2s-design-b1.jpg')
      padding-top r(150)
    #design-b2
      background-image url('../../../assets/mobile/2s-design-b2.jpg')
      .p1
        top r(730)
        left r(250)
      .p2
        top r(754)
        left r(440)
    #design-b3
      background-image url('../../../assets/mobile/2s-design-b3.jpg')
      .w
        padding r(100) r(200) 0 0
        text-align right
    #design-b4
      background-image url('../../../assets/mobile/2s-design-b4.jpg')
      .w
        padding r(80) 0 0 r(40)
        text-align left
        .p2
            margin 0
  .robot-design
    .w
      .p1
        font-size r(46)
      .p2
        font-size r(24)
</style>



// WEBPACK FOOTER //
// src/views/robot/2s/design.vue